import NavbarSection from "../components/navbar/Navbar";
import Hero from "../components/hero/Hero";
import Footer from "../components/footer/Footer";
import SearchSection from "../components/section/SearchSection";

const CarsPage = () => {
  return (
    <>
      <NavbarSection />
      <Hero />
      <SearchSection />
      <Footer />
    </>
  );
};

export default CarsPage;
